import React from 'react'
import { Box, Typography } from '@mui/material'
import i18next from 'i18next'
import { useAbout } from '../../hooks/useAbout'
import LoadingPage from './LoadingPage'
const DownloadBrochure = () => {

    const { about: aboutData, isLoading } = useAbout()
    if (isLoading) return <LoadingPage />
    const { data } = aboutData
    const pdf = data?.files?.filter(file => file.type.includes('pdf'))
    let lng = i18next.language
    return (
        <div>
            <Box sx={{
                backgroundColor: theme => theme.palette.primary.main,
                borderRadius: 1,
                p: 1,
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                zIndex: 999,
                width: 'max-content',
                textAlign: 'center'
            }} >
                <Typography sx={{ color: '#000' }}>
                    <a href={pdf[0]?.file} download={true}
                        target='_blank'
                        rel="noreferrer"
                        style={{ color: '#fff', textDecoration: "none" }} >
                        {lng === 'en' ? "Download Brochure" : "تحميل البرشور"}
                    </a>
                </Typography>
            </Box>
        </div>
    )
}

export default DownloadBrochure